import { ADD_MODULE, ADD_PREFERENCE, APPLY_SORTING, DELETE_MODULE, DELETE_PREFERENCE, EDIT_MODULE, EDIT_PREFERENCE, GET_MODULES_LIST } from "store/actions/emailPreferences";

const initialState = {
  modules: [],
};

function getModulesList(state, payload) {
  const { data } = payload;
  console.log("payload", payload);
  const stateObj = {
    ...state,
    modules: data?.body,
  };
  return stateObj;
}

function addNewModule(state, payload) {
  return state;
}

function editModule(state, payload) {
  return state;
}

function deleteModule(state, payload) {
  return state;
}

function addPreference(state, payload) {
  return state;
}

function editPreference(state, payload) {
  return state;
}

function deletePreference(state, payload) {
  return state;
}

function applySorting(state, payload) {
  return state;
}

const EmailPreferences = (state = initialState, { type, payload = null }) => {
  switch (type) {
    case GET_MODULES_LIST:
      return getModulesList(state, payload);
    case ADD_MODULE:
      return addNewModule(state, payload);
    case EDIT_MODULE:
      return editModule(state, payload);
    case DELETE_MODULE:
      return deleteModule(state, payload);
    case ADD_PREFERENCE:
      return addPreference(state, payload);
    case EDIT_PREFERENCE:
      return editPreference(state, payload);
    case DELETE_PREFERENCE:
      return deletePreference(state, payload);
    case APPLY_SORTING:
      return applySorting(state, payload);

    default:
    return state;
  };
}

export default EmailPreferences;